
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    name: 'c-sign-recal-modal'
})
export default class CBudgetUserSignRecalModal extends Vue {
    private showModal = false;
    private commentTxt = '';

    private showEvent() {
        this.showModal = true;
    }

    private recalClk() {
        this.$emit('recalClk', this.commentTxt.trim());
        this.commentTxt = '';
        this.showModal = false;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get title() {
        const obj = {
            title: this.getBudgetText('user_sign_recal_modal.title'), // Отзыв подписи
            coment: this.getBudgetText('user_sign_recal_modal.coment'), // Внимание! Отзыв Вашего ЭЦП автоматически отзовет подписи всех участников подписания БЗ
            recalSign: this.getBudgetText('button.recalSign'), // Отозвать ЭЦП
            cancel: this.getBudgetText('button.cancel'), // Отменить
            commentPlaceholder: this.getBudgetText('toast.comment_placeholder'), // Добавьте комментарий
        }
        return obj;
    }
}
